import { render, staticRenderFns } from "./UserSettingStrongPwd.vue?vue&type=template&id=7f2da66a&scoped=true&"
import script from "./UserSettingStrongPwd.vue?vue&type=script&lang=js&"
export * from "./UserSettingStrongPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2da66a",
  null
  
)

export default component.exports